import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney } from "../Helpers";

export default function View({ data }) {

	const appContext = useContext(AppContext);

	/* Place states here */

	function view() {
		appContext.navTo({
			item: 'side-view',
			subItem: 'grading-system-options',
			extraItem: data.uuid,
		})
	}

	return (
		<div className="One" onClick={view}>
			<div className="row">

				<div className="col-12">
					<h6
						style={{
							fontSize: "14px"
						}}
						className="font-semi-bold"
					>
						{data.title}
					</h6>
				</div>
				
				

			</div>
		</div>
	)

}